import { useEffect } from 'react';

import { getters } from 'core/middlewares/effects/orchestrator/workflows/getters';
import { actions as contentActions } from 'core/use-cases/content/slice';
import { useQueryState } from 'core/use-cases/utilities';
import { useDispatch } from 'react-redux';

import { useContentSelector } from '../selectors';
import { actions } from '../slice';

export function useStarlinkContent(document: string, enabled = false) {
  const dispatch = useDispatch();
  const hasAccessToken = getters.hasAccessToken();

  const { data, isError, isIdle, isLoading, isSuccess } = useQueryState(
    useContentSelector,
    document,
  );

  useEffect(() => {
    if (!hasAccessToken || !enabled) {
      return;
    }

    if (Object.keys(data).length) {
      return;
    }

    dispatch(actions.starlinkContentFetch.request({ document }));

    return () => {
      dispatch(contentActions.contentCleanUp(document));
    };
  }, [enabled, hasAccessToken]);

  return {
    data,
    isError,
    isIdle,
    isLoading,
    isSuccess,
  };
}
